import IntroductionStep from "@/components/Exercises/DrawHappyPlace/IntroductionStep";
import { Button } from "@/components/ui/button";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { useAuthStore } from "@/lib/stores/authStore";
import { useState, useEffect } from "react";
import ConfirmationModal from "@/components/ui/confirmation-modal";
import { happyPlaceApi } from "@/lib/api/happyPlace";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/happy-place/"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Draw My Happy Place - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "happy-place.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const { user, setRedirectAfterAuth } = useAuthStore();
  const isChildUserLoggedIn = user?.audience === "CHILD";
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [hasDrawings, setHasDrawings] = useState(false);
  const [isCheckingDrawings, setIsCheckingDrawings] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkDrawings = async () => {
      if (isChildUserLoggedIn) {
        try {
          const drawings = await happyPlaceApi.getDrawings();
          setHasDrawings(drawings.length > 0);
        } catch (error) {
          console.error("Error checking drawings:", error);
          setHasDrawings(false);
        }
      }
      setIsCheckingDrawings(false);
    };

    checkDrawings();
  }, [isChildUserLoggedIn]);

  const handleStartDrawing = () => {
    if (!user) {
      setRedirectAfterAuth(
        "/children/exercises/happy-place/drawing-board"
      );
      setShowAuthModal(true);
      return;
    }

    navigate({ to: "/children/exercises/happy-place/drawing-board" });
  };

  const handleRegisterRedirect = () => {
    navigate({ to: "/auth/register" });
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <div className="flex flex-col space-y-2">
          <Button className="w-full" onClick={handleStartDrawing}>
            <FormattedMessage id="drawing.startExercise" />
          </Button>
          {!isCheckingDrawings && hasDrawings && (
            <Link to="/children/exercises/happy-place/draw-summary">
              <Button variant="secondary" className="w-full">
                <FormattedMessage
                  id="happy-place.viewDrawings"
                  defaultMessage="View My Drawings"
                />
              </Button>
            </Link>
          )}
        </div>
      }
    >
      <IntroductionStep />
      <ConfirmationModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onConfirm={handleRegisterRedirect}
        titleKey="common.auth.title"
        messageKey="common.auth.message"
        confirmButtonTextKey="common.auth.register"
        cancelButtonTextKey="common.cancel"
      />
    </ExerciseLayout>
  );
}
